import { useMemo } from 'react';
import SovosProductMenu from '../../sovos-product-menu';
const useProductSwitcherProps = _ref => {
  let {
    onSelectProduct,
    product,
    products,
    productSwitcherLabel,
    ProductSwitcherSlot,
    productSwitcherSlotProps
  } = _ref;
  const props = useMemo(() => {
    const {
      onSelectProduct: onSelectProductSlotProp,
      selectedProduct: selectedProductSlotProp,
      products: productsSlotProp,
      tooltipText,
      ...otherSlotProps
    } = productSwitcherSlotProps !== null && productSwitcherSlotProps !== void 0 ? productSwitcherSlotProps : {};
    const onSelectProductFn = onSelectProductSlotProp !== null && onSelectProductSlotProp !== void 0 ? onSelectProductSlotProp : onSelectProduct;
    const selectedProduct = selectedProductSlotProp !== null && selectedProductSlotProp !== void 0 ? selectedProductSlotProp : product;
    const calculatedProduct = typeof selectedProduct === 'object' ? selectedProduct : {
      id: selectedProduct,
      name: selectedProduct
    };
    const productItems = productsSlotProp !== null && productsSlotProp !== void 0 ? productsSlotProp : products;
    return {
      onSelectProduct: onSelectProductFn,
      products: Array.isArray(productItems) && productItems.length ? productItems : [],
      selectedProduct: calculatedProduct,
      tooltipText: tooltipText !== null && tooltipText !== void 0 ? tooltipText : productSwitcherLabel,
      ...otherSlotProps
    };
  }, [onSelectProduct, product, products, productSwitcherLabel, productSwitcherSlotProps]);
  const Component = ProductSwitcherSlot !== null && ProductSwitcherSlot !== void 0 ? ProductSwitcherSlot : SovosProductMenu;
  return [props, Component];
};
export default useProductSwitcherProps;